__turbopack_context__.v({
  "badgesWrapper": "kkLv3q_badgesWrapper",
  "keywordsLabel": "kkLv3q_keywordsLabel",
  "keywordsWrapper": "kkLv3q_keywordsWrapper",
});
